<template>
    <div :class="`convention-teaser-alert ${mode}`" v-if="convention.latestPush">
        <action name="link" @click="openPopin">
            <typo name="body-12-light">
                Consulter la dernière veille juridique du {{ sentAt }}
            </typo>
        </action>
    </div>
</template>

<script>
import { Services } from "src/services/Services";
import { EventBus } from "src/bus/eventBus";

export default {
    props: ["convention", "mode"],
    methods: {
        openPopin() {
            EventBus.$emit("push-popin:show", this.convention.latestPush.id);
        },
    },
    computed: {
        dico() {
            return this.$privateDico.convention.teaser;
        },
        sentAt() {
            if (this.convention.latestPush) {
                return Services.moment(this.convention.latestPush.sentAt).format("LLL");
            } else {
                return null;
            }
        },
    },
};
</script>

<style scoped lang="sass">
.convention-teaser-alert
    padding: 10px 0 0 30px
</style>
